document.addEventListener('DOMContentLoaded', () => {
    let vantaCanvas = null;

    function initVanta() {
        const isDesktop = window.innerWidth > 768;

        if (vantaCanvas && !isDesktop) {
            vantaCanvas.destroy();
            vantaCanvas = null;
        }

        if (!vantaCanvas && isDesktop && window.VANTA && VANTA.GLOBE) {
            vantaCanvas = VANTA.GLOBE({
                el: "#has-vanta",
                mouseControls: false,
                touchControls: false,
                gyroControls: false,
                minHeight: 200,
                minWidth: 200.00,
                scale: 1.00,
                color: 0xdadbdd,
                color2Alpha: 0,
                backgroundAlpha: 0,
                backgroundColor: 0xffffff
            });
        }
    }

    initVanta();
    window.addEventListener('resize', initVanta);
});
